import { useCallback, useEffect, useRef } from 'react';

import { Notifications } from './notificationsStore';

export const useAutoCloseNotification = ({
  id,
  autoClose,
  closeDuration,
}: {
  id: string;
  autoClose?: boolean;
  closeDuration: number;
}) => {
  const timeoutRef = useRef<NodeJS.Timeout>();

  const startTimer = useCallback(() => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    timeoutRef.current = setTimeout(() => {
      Notifications.hide(id);
    }, closeDuration);
  }, [closeDuration, id]);

  useEffect(() => {
    if (autoClose) {
      startTimer();
    }

    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, [autoClose, startTimer]);

  const handleMouseEnter = useCallback(() => {
    if (autoClose && timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
  }, [autoClose]);

  const handleMouseLeave = useCallback(() => {
    if (autoClose) {
      startTimer();
    }
  }, [autoClose, startTimer]);

  return {
    handleMouseEnter,
    handleMouseLeave,
  };
};
